import { defineMessages, FormattedMessage } from 'react-intl';

import { CustomizationSectionTitle } from '../../../CustomizationSectionTitle';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationDetailsDressingsTitle = (props: Props) => {
  const { dressingMode, hasNoSelectedDressing, maxDressingsPortions } = props;

  if (dressingMode === 'onTheSide' && !hasNoSelectedDressing) {
    return (
      <CustomizationSectionTitle>
        <FormattedMessage
          {...messages.onTheSideTitle}
          values={{ max_portions: maxDressingsPortions }}
        />
      </CustomizationSectionTitle>
    );
  }

  return (
    <CustomizationSectionTitle>
      <FormattedMessage {...messages.yourDressingsTitle} />
    </CustomizationSectionTitle>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  yourDressingsTitle: {
    defaultMessage: 'Your dressings',
    description: 'Customization | Dressing details | Your dressings title',
  },
  onTheSideTitle: {
    defaultMessage: 'Select up to {max_portions} total portions:',
    description: 'Customization | Dressing details | On the side title',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  dressingMode: 'onTheSide' | 'mixedIn';
  hasNoSelectedDressing: boolean;
  maxDressingsPortions: number;
};
